import {
  AccountModel,
  AccountGetAttributes,
  AccountCreateAttributes,
  AccountUpdateAttributes,
  AccountCollection,
} from 'src/models/AccountModel';
import { Notify } from 'quasar';
import {
  AccountAdapterInteface,
  ListAccountsInput as BaseListAccountsInput,
} from 'src/adapter/AccountAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListAccountsInput = BaseListAccountsInput;
export class AccountApiClass {
  adapter: AccountAdapterInteface;
  constructor(adapter: AccountAdapterInteface) {
    this.adapter = adapter;
  }
  async listAccounts(
    conditions: ListAccountsInput
  ): Promise<{ total: number; data: AccountCollection }> {
    try {
      const res = await this.adapter.listAccounts(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (account: AccountGetAttributes) => new AccountModel(account)
        ),
      };
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async getAccount(id: string): Promise<AccountModel> {
    try {
      const account = await this.adapter.getAccount(id);
      return new AccountModel(account);
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async createAccount(
    attributes: AccountCreateAttributes
  ): Promise<AccountModel> {
    try {
      const account = await this.adapter.createAccount(attributes);
      return new AccountModel(account);
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async updateAccount(
    id: string,
    attributes: AccountUpdateAttributes
  ): Promise<AccountModel> {
    try {
      const account = await this.adapter.updateAccount(id, attributes);
      return new AccountModel(account);
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async deleteAccount(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteAccount(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
}
